import React, { ReactElement } from 'react';
import { LoginViewProps } from './LoginPageViewProps';
import { LoginPageFormSchema } from './LoginPageFormSchema';
import { TextInputField } from '../../modules/forms/fields/TextInputField';
import { Form } from '../../modules/forms/Form';
import {
  VehicleLookupIdentityStep,
  VehicleLookupStep,
  VehicleLookupSteps,
  VehicleLookupSubmit,
  VehicleLookupVwLayout,
} from '../../modules/login/VehicleLookupVw';

export function LoginPageVwView({ initialFormData, onSubmit }: LoginViewProps): ReactElement {
  return (
    <VehicleLookupVwLayout
      withContactMe
      intro="By entering your registration number and ID, we can identify your previous interactions and vehicle service history to provide you with a more personalised customer experience."
    >
      <Form schema={LoginPageFormSchema} defaultValues={initialFormData} onSubmit={onSubmit}>
        <VehicleLookupSteps>
          <VehicleLookupStep number={1} title="Vehicle registration number">
            <TextInputField
              name="registrationNumber"
              label="Vehicle registration number"
              placeholder="e.g. ND16FTGP"
              type="text"
              rules={{ max: 15 }}
              trimString
              errorBelow
            />
          </VehicleLookupStep>
          <VehicleLookupIdentityStep />
        </VehicleLookupSteps>
        <VehicleLookupSubmit />
      </Form>
    </VehicleLookupVwLayout>
  );
}
